import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

interface ImageData {
  src: string;
  alt: string;
  text: string;
}

interface HotelDetailImageSliderProps {
  images: ImageData[];
}

// TODO:画像の修正
export const HotelDetailImageSlider: React.FC<HotelDetailImageSliderProps> = ({
  images,
}) => {
  return (
    <div className="image-slider-container" style={{ width: '100%' }}>
      <Swiper
        spaceBetween={10}
        slidesPerView={1.1}
        centeredSlides={false}
        style={{ width: '100%' }}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image.src}
              alt={image.alt}
              style={{ height: '362px' }}
              className="w-full h-auto object-cover"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
